import { useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import { answerTrackerQuestionMap } from "../utils";
import axios from "axios";

export const LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY =
    "BWS_ANSWER_TRACKER_SESSION_ID";

function getAnswerTrackerSessionId() {
    const sessionId = localStorage.getItem(
        LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY
    );

    if (!sessionId) {
        const newSessionId = uuidv4();
        localStorage.setItem(
            LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY,
            newSessionId
        );
        return newSessionId;
    }

    return sessionId;
}

const setAnswerTrackerSessionId = (id: string) => {
    localStorage.setItem(LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY, id);
};

export function useAnswerTracker() {
    const trackAnswer = useCallback(
        async (questionName: string, answer: any, allAnswers: any) => {
            let data = {} as Record<string, any>;
            let shouldTrackAnswer = !questionName.endsWith("Splash");

            data.sessionId = getAnswerTrackerSessionId();
            if (allAnswers["email"]) {
                data.email = allAnswers["email"];
            }

            // Include hs_offer from localStorage if present
            const hsOffer = localStorage.getItem("hs_offer");
            if (hsOffer) {
                data.customData = {
                    ...data.customData,
                    quiz_promotional_offer: hsOffer,
                };
            }

            if (answerTrackerQuestionMap[questionName]) {
                const mappedData = answerTrackerQuestionMap[questionName](
                    answer,
                    allAnswers
                );
                if (mappedData) {
                    data = { ...data, ...mappedData };
                } else {
                    // nothing to track yet
                    shouldTrackAnswer = false;
                }
            } else {
                data.customData = {
                    [questionName]: answer,
                };
            }

            const sessionTrackerEndpoint =
                "https://core.builtwithscience.com/internal/public/session/track";

            if (shouldTrackAnswer) {
                const response = await axios.post(sessionTrackerEndpoint, data);
                if (response.data.data.sessionId) {
                    setAnswerTrackerSessionId(response.data.data.sessionId);
                }
                const iacConnectionId = localStorage.getItem("iacConnectionId");
                if (iacConnectionId) {
                    axios
                        .post(
                            "https://staging.ws.builtwithscience.com/message/publish",
                            {
                                connectionId: iacConnectionId,
                                event: "quiz",
                                message: JSON.stringify(data),
                            }
                        )
                        .catch((error) => {
                            console.error("Error sending IAC message:", error);
                        });
                }
            } else {
                console.log("skip tracking answer", questionName, answer);
            }
        },
        []
    );

    return { trackAnswer };
}
